export enum CookieEnum {
    Partnership = 'partnership',
}
